import type { HistogramChartYAxisProps } from '../../../histogram/types/histogram-props.js';
import type { MappedPositionedAxes } from '../types/slots.js';

/* Only last configuration from each position will be taken, so if there are multiple YAxis with the same position, only the last one will be used.
 */
export function yAxisConfigMapping(
  axes: HistogramChartYAxisProps[],
): MappedPositionedAxes {
  return axes.reduce<MappedPositionedAxes>((result, { position, ...rest }) => {
    //Axis position can be undefined. In that case, we treat it as left (the same way is done in Histogram)
    const axisPosition = position === 'right' ? 'right' : 'left';

    return {
      ...result,
      [axisPosition]: {
        ...rest,
        type: rest.scale === 'log' ? 'log' : 'numerical',
      },
    };
  }, {});
}
